export default __webpack_public_path__ + "static/media/seegno.66de2e1f.jpeg";